export const GENDERS = [
  { viewValue: 'Male', value: 'Male' },
  { viewValue: 'Female', value: 'Female' },
  { viewValue: 'Other', value: 'Other' }
];